import { useEffect, useState } from "react";
// import { TileLayer } from "leaflet";
// import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import { dmd_utils } from "../utils/frfr-dmd-utils";
import { rapidozi_dummy_utils, rapidozi_dummysmarty_utils, smartydummy_backend_special_instance } from "../utils/frfr-rapidozi-dummy-utils";
import { _zzyourmap_ajax } from "../utils/zz/zz-yourmap-ajax-adapter";
import { Easy69_v1 } from "../utils/frfr-easy69-utils";
import Komentar from "./Komentar";
import UniBtn from "./UniBtn";
import UniImage from "./UniImage";
import UniSpinnerClassic from "./UniSpinnerClassic";
import UniLimiter from "./UniLimiter";
import { rapidozi_contact_utils } from "../utils/frfr-rapidozi-contact-utils";
import { yourmapNavMaker, _zzyourmap_routing_browser_title_update } from "../utils/zz/zz-yourmap-routing";


// DEFAULT COMPONENT
const YourmapCardTeaser = (props) => {
  const {
    route_destination_id,
    viarouterNavigate,
  } = props.appPack;
  const item = props.item;
  const thing_id = item.of_id;
  // const img_url_full = _zzyourmap_extract_smestaj_main_img_url(item);
  const img_url_full = item._main_img_url;
  const style = {
    backgroundImage: 'url("' + img_url_full + '")',
  };
  //
  const nav_path = (() => {
    if (item.vr_tablename === 'ym_table_smestaj') {
      return yourmapNavMaker.ROOT_SMESTAJ_ITEM(route_destination_id, thing_id);
    } else if (item.vr_tablename === 'ym_table_restoran') {
      return yourmapNavMaker.ROOT_RESTORAN_ITEM(route_destination_id, thing_id);
    } else if (item.vr_tablename === 'ym_table_servis') {
      return yourmapNavMaker.ROOT_SERVIS_ITEM(route_destination_id, thing_id);
    } else if (item.vr_tablename === 'ym_table_prodavnica') {
      return yourmapNavMaker.ROOT_PRODAVNICA_ITEM(route_destination_id, thing_id);
    } else if (item.vr_tablename === 'ym_table_aktivnost') {
      return yourmapNavMaker.ROOT_AKTIVNOST_ITEM(route_destination_id, thing_id);
    } else if (item.vr_tablename === 'ym_table_znamenitost') {
      return yourmapNavMaker.ROOT_ZNAMENITOST_ITEM(route_destination_id, thing_id);
    } else if (item.vr_tablename === 'ym_table_ostalo_v2') {
      return yourmapNavMaker.ROOT_OSTALO_ITEM(route_destination_id, thing_id);
    } else if (item.vr_tablename === 'ym_table_ostalo_v1') {
      // if (item.smestaj_tab === 'OSTALO') {
      // return yourmapNavMaker.ROOT_OSTALO_ITEM(route_destination_id, thing_id);
      if (item.smestaj_tab === 'blog') {
        return yourmapNavMaker.ROOT_BLOG_ITEM(route_destination_id, thing_id);
      }
    }
  })();
  //
  //
  return (
    <>
      <div className="yourmap__card yourmap__card--teaser uu-shadow-alien-fluent2-tile-shadow" data-item-ofid={thing_id}>
        <div className="yourmap__card__header-cover" style={style}></div>
        <div className="yourmap__card__body-room">
          <div className="yourmap__card-destinacija-content">
            <div className="yourmap__article__title-and-subtitle">
              {/*
              <h3>Olive Branch Mediterranean</h3>
              <p>Fresh mediterranean flawors with grilled seafood, homemade hummus, and healthy options in a bright airy space.</p>
              */}
              <h3>{item.smestaj_naslov}</h3>
              <p>{item.smestaj_podnaslov}</p>
            </div>
            <div className="uu-w-1-1 unirole-antigap-fix">
              <div className="uu-vector uu-gaps-m-1rem">
                <UniBtn
                  wide
                  fullWidth
                  titleBeforeIcon
                  title="Više"
                  i_NOT="fa fa-map-o"
                  extraClass="yourmap__theme__custom-btn-blue"
                  handleClick={(e) => {
                    e.preventDefault();
                    /*
                    if (item.vr_tablename === 'ym_table_smestaj') {
                      setRouteRoot('ROOT_SMESTAJ_ITEM', thing_id);
                    } else if (item.vr_tablename === 'ym_table_restoran') {
                      setRouteRoot('ROOT_RESTORAN_ITEM', thing_id);
                    } else if (item.vr_tablename === 'ym_table_ostalo_v1') {
                      if (item.smestaj_tab === 'SERVISI') {
                        setRouteRoot('ROOT_SERVIS_ITEM', thing_id);
                      } else if (item.smestaj_tab === 'OSTALO') {
                        setRouteRoot('ROOT_OSTALO_ITEM', thing_id);
                      }
                    }
                    */
                    viarouterNavigate(nav_path);
                  }}
                  href={nav_path}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default YourmapCardTeaser;